import React from 'react';
import './SearchFilterBar.css';

const SearchFilterBar = ({
  searchQuery,
  setSearchQuery,
  roleFilter,
  setRoleFilter,
  statusFilter,
  setStatusFilter
}) => {
  return (
    <div className="search-filter-bar">
      {/* Search Input */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Search by email..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
        {searchQuery && (
          <button 
            className="clear-search"
            onClick={() => setSearchQuery('')}
            title="Clear search"
          >
            ×
          </button>
        )}
      </div>

      {/* Role Filter */}
      <select
        value={roleFilter}
        onChange={(e) => setRoleFilter(e.target.value)}
        className="filter-select"
      >
        <option value="ALL">All Roles</option>
        <option value="ADMIN">Admin Only</option>
        <option value="SUPER_ADMIN">Super Admin Only</option>
      </select>

      {/* Status Filter */}
      <select
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
        className="filter-select"
      >
        <option value="ALL">All Status</option>
        <option value="ACTIVE">Active Only</option>
        <option value="INACTIVE">Inactive Only</option>
      </select>
    </div>
  );
};

export default SearchFilterBar;

